const PropTypes = require('prop-types');
const React = require('react');
const ScrollToItem = require('./scroll_to_item.js');

const classNames = require('classnames');

const DOWN_ARROW = 40;
const UP_ARROW = 38;
const ENTER = 13;

class ScrollableList extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.handleArrows = this.handleArrows.bind(this);

    this.state = {
      focused: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.items !== nextProps.items) {
      this.setState({ focused: null });
    }
  }

  componentDidUpdate() {
    const focusedItem = this.refs[`item-${this.state.focused}`];
    const list = this.refs.list;
    new ScrollToItem(focusedItem, list).scrollToItem();
  }

  onChange(e) {
    if (this.props.changeEvent) {
      this.props.changeEvent(e);
    }
  }

  handleArrows(e) {
    if (e.keyCode === DOWN_ARROW) {
      this.focusNext();
    } else if (e.keyCode === UP_ARROW) {
      this.focusPrevious();
    } else if (e.keyCode === ENTER && this.props.onEnter) {
      this.props.onEnter(e);
    }
  }

  // used by ProductSearchForm in handleSubmit()
  focusedItem() {
    return this.props.items[this.currentFocus()];
  }

  currentFocus() {
    let currentFocus = this.state.focused;
    if (currentFocus === null) {
      currentFocus = -1;
    }
    return currentFocus;
  }

  focusNext() {
    const currentFocus = this.currentFocus();
    if (currentFocus < this.props.items.length - 1) {
      this.setState({ focused: currentFocus + 1 });
    }
  }

  focusPrevious() {
    const currentFocus = this.currentFocus();
    if (currentFocus > 0) {
      this.setState({ focused: currentFocus - 1 });
    }
  }

  items() {
    return this.props.items.map((result, index) =>
      <li
        key={result.id}
        ref={`item-${index}`}
        className={classNames({
          active: this.state.focused === index,
        })}
      >
        {this.props.renderItem(result)}
      </li>
    );
  }

  get shouldShowItems() {
    return this.props.items.length && !this.props.hideItems;
  }

  renderItems() {
    if (!this.shouldShowItems) {
      return null;
    }
    return (
      <ul className={this.props.listClass} ref="list">
        {this.items()}
      </ul>
    );
  }

  render() {
    return (
      <div>
        <input
          autoComplete={this.props.autoComplete}
          autoFocus={this.props.autoFocus}
          className={this.props.className}
          name={this.props.name}
          placeholder={this.props.placeholder}
          type={this.props.type}
          ref="input"
          onChange={this.onChange}
          onKeyDown={this.handleArrows}
          value={this.props.inputValue}
        />
        {this.renderItems()}
      </div>
    );
  }
}

ScrollableList.propTypes = {
  renderItem: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  hideItems: PropTypes.bool,
  changeEvent: PropTypes.func,
  onEnter: PropTypes.func,
  listClass: PropTypes.string,
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  inputValue: PropTypes.string,
};

ScrollableList.defaultProps = {
  hideItems: false,
};

module.exports = ScrollableList;



// WEBPACK FOOTER //
// ./javascripts/components/shared/scrollable_list.jsx